<template>
  <div class="ba_f outerLayer">
    <div class="sellback" id="box">
      <div class="login_wrap">
        <div class="warp_content">
          <!-- 动态标题：根据当前表单类型切换 -->
          <div class="title">
            <h3>
              商联未来数智平台
            </h3>
            <span class="txt"></span>
          </div>

          <!-- 1. 密码登录表单（默认显示） -->
          <el-form
            v-if="currentForm === 'pwdLogin'"
            :model="ruleForm"
            status-icon
            :rules="pwdRules"
            ref="pwdForm"
            label-width="0"
            class="demo-ruleForm"
          >
            <el-form-item prop="account">
              <el-input
                prefix-icon="iconfont iconzhanghao mar_l5"
                v-model="ruleForm.account"
                autocomplete="off"
                placeholder="请输入登录账号"
                style="width: 300px;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input
                prefix-icon="iconfont iconmima mar_l5"
                v-model="ruleForm.checkPass"
                autocomplete="off"
                type="password"
                placeholder="请输入密码"
                style="width: 300px;"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 300px;"
                @click.native.prevent="SubmitFunc"
              >登录</el-button>
            </el-form-item>
            <div>
              <span class="forget_pwd" @click="switchForm('forgetPwd')">忘记密码</span>
              <span class="login_yzm" @click="switchForm('codeLogin')">验证码登录</span>
            </div>
          </el-form>

          <!-- 2. 验证码登录表单（点击切换显示） -->
          <el-form
            v-if="currentForm === 'codeLogin'"
            :model="codeForm"
            status-icon
            :rules="codeRules"
            ref="codeForm"
            label-width="0"
            class="demo-ruleForm"
          >
            <el-form-item prop="account">
              <el-input
                prefix-icon="iconfont iconzhanghao mar_l5"
                v-model="codeForm.account"
                autocomplete="off"
                placeholder="请输入手机号"
                style="width: 300px;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                prefix-icon="iconfont iconcode mar_l5"
                v-model="codeForm.code"
                autocomplete="off"
                placeholder="请输入验证码"
                style="width: 210px; float: left;"
              ></el-input>
              <el-button
                type="default"
                style="width: 80px; float: right; height: 40px;padding: 0!important;"
                @click="getVerifyCode"
                :disabled="codeBtnDisabled"
              >{{ codeBtnText }}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 300px;"
                @click.native.prevent="submitCodeLogin"
              >登录</el-button>
            </el-form-item>
            <div>
              <span class="forget_pwd" @click="switchForm('forgetPwd')">忘记密码</span>
              <span class="login_yzm" @click="switchForm('pwdLogin')">密码登录</span>
            </div>
          </el-form>

          <!-- 3. 忘记密码表单（点击切换显示） -->
          <el-form
            v-if="currentForm === 'forgetPwd'"
            :model="forgetForm"
            status-icon
            :rules="forgetRules"
            ref="forgetForm"
            label-width="0"
            class="demo-ruleForm"
          >
            <el-form-item prop="account">
              <el-input
                prefix-icon="iconfont iconzhanghao mar_l5"
                v-model="forgetForm.account"
                autocomplete="off"
                placeholder="请输入绑定的手机号"
                style="width: 300px;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                prefix-icon="iconfont iconcode mar_l5"
                v-model="forgetForm.code"
                autocomplete="off"
                placeholder="请输入验证码"
                style="width: 210px; float: left;"
              ></el-input>
              <el-button
                type="default"
                style="width: 80px; float: right; height: 40px;padding: 0!important;"
                @click="getForgetCode"
                :disabled="forgetBtnDisabled"
              >{{ forgetBtnText }}</el-button>
            </el-form-item>
            <el-form-item prop="newPass">
              <el-input
                prefix-icon="iconfont iconmima mar_l5"
                v-model="forgetForm.newPass"
                autocomplete="off"
                type="password"
                placeholder="请输入新密码"
                style="width: 300px;"
              ></el-input>
            </el-form-item>
            <el-form-item prop="confirmPass">
              <el-input
                prefix-icon="iconfont iconmima mar_l5"
                v-model="forgetForm.confirmPass"
                autocomplete="off"
                type="password"
                placeholder="请确认新密码"
                style="width: 300px;"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 300px;"
                @click.native.prevent="submitForgetPwd"
              >重置密码</el-button>
            </el-form-item>
            <div>
              <span class="forget_pwd" @click="switchForm('pwdLogin')">返回登录</span>
              <span class="login_yzm" @click="switchForm('codeLogin')">验证码登录</span>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/loginysw.css";
import IndexApi from "@/api/index.js";
import bgimg from "@/assets/img/login_bg.jpg";
import UserApi from "@/api/user.js";
import { setCookie, setSessionStorage, delCookie } from "@/utils/base.js";

export default {
  data() {
    return {
      currentForm: "pwdLogin",
      loading: true,
      bgimg_url: bgimg,
      logining: false,

      // 1. 密码登录表单数据
      ruleForm: {
        account: "",
        checkPass: "",
      },

      // 2. 验证码登录表单数据
      codeForm: {
        account: "",
        code: "",
      },

      // 3. 忘记密码表单数据
      forgetForm: {
        account: "",
        code: "",
        newPass: "",
        confirmPass: "",
      },

      // 验证码按钮状态（倒计时）
      codeBtnDisabled: false,
      codeBtnText: "获取验证码",
      forgetBtnDisabled: false,
      forgetBtnText: "获取验证码",

      // 验证规则
      pwdRules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      codeRules: {
        account: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      forgetRules: {
        account: [{ required: true, message: "请输入绑定的手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        newPass: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmPass: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.forgetForm.newPass) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },

      baseData: {},
      icp: "",
    };
  },
  mounted() {},
  created() {
    delCookie("token");
    this.getData();
    // 开发环境自动填充账号密码
    if (process.env.NODE_ENV !== "production") {
      this.ruleForm.account = process.env.NODE_USER || "";
      this.ruleForm.checkPass = process.env.NODE_PASS || "";
    }
  },
  methods: {
    // 核心方法：切换表单类型
    switchForm(formType) {
      this.currentForm = formType;
      // 切换时清空对应表单数据（可选）
      if (formType === "codeLogin") {
        // 复用密码登录的账号
        this.codeForm.account = this.ruleForm.account;
      } else if (formType === "forgetPwd") {
        this.forgetForm.account = this.ruleForm.account;
      } else if (formType === "pwdLogin") {
        // 返回登录时清空验证码/忘记密码表单
        this.codeForm.code = "";
        this.forgetForm = { account: "", code: "", newPass: "", confirmPass: "" };
      }
    },

    // 获取基础配置
    getData() {
      IndexApi.base({})
        .then((res) => {
          if (res.data.config.icp) this.icp = res.data.config.icp;
          if (res.data.config.kmd_support === "w7") {
            window.location.href = `${window.location.protocol}//${window.location.host}`;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 1. 密码登录提交
    SubmitFunc() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          const Params = {
            username: this.ruleForm.account,
            password: this.ruleForm.checkPass,
          };
          UserApi.login(Params, true)
            .then((res) => {
              this.logining = false;
              if (res.code === 1) {
                console.log(res.data,'1111111')
                setCookie("userinfo", res.data);
                setCookie("is_supply", res.data.supply ? 1 : 0);
                if (res.data.token) setCookie("token", res.data.token);
                setCookie("isLogin", true);
                 this.pathroute = res.data.path
                console.log('this.pathroute',this.pathroute);
                this.$router.push(this.pathroute || "/");
                this.$router.push(res.data.path || "/");
              } else {
                this.$message.error("登录失败");
              }
            })
            .catch(() => {
              this.logining = false;
            });
        }
      });
    },

    // 2. 验证码登录 - 获取验证码
    getVerifyCode() {
      if (!this.codeForm.account) {
        this.$message.warning("请先输入手机号");
        return;
      }
      const Params = {
        account: this.codeForm.account
      };
      UserApi.getVerifyCode(Params, true)
      .then((res) => {
        this.logining = false;
        this.$message.success("验证码已发送");
          // 倒计时逻辑
          this.codeBtnDisabled = true;
          let count = 60;
          this.codeBtnText = `${count}s后重新获取`;
          const timer = setInterval(() => {
          count--;
          this.codeBtnText = `${count}s后重新获取`;
          if (count <= 0) {
              clearInterval(timer);
              this.codeBtnDisabled = false;
              this.codeBtnText = "获取验证码";
            }
          }, 1000);
      })
      .catch(() => {
        this.logining = false;
      });
    },

    // 2. 验证码登录提交
    submitCodeLogin() {
      this.$refs.codeForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          const Params = {
            account: this.codeForm.account,
            code: this.codeForm.code,
          };
          // 调用验证码登录接口（需替换为实际接口）
          UserApi.loginCode(Params, true)
            .then((res) => {
              this.logining = false;
              if (res.code === 1) {
                setCookie("userinfo", res.data);
                setCookie("is_supply", res.data.supply ? 1 : 0);
                if (res.data.token) setCookie("token", res.data.token);
                setCookie("isLogin", true);
                this.pathroute = res.data.path
                this.$router.push(this.pathroute || "/");
                this.$router.push(res.data.path || "/");
              } else {
                this.$message.error("登录失败");
              }
            })
            .catch(() => {
              this.logining = false;
            });
        }
      });
    },

    // 3. 忘记密码 - 获取验证码
    getForgetCode() {
      if (!this.forgetForm.account) {
        this.$message.warning("请先输入绑定的手机号/账号");
        return;
      }
      // 调用找回密码验证码接口（示例）
      UserApi.getVerifyCode({ account: this.forgetForm.account })
        .then(() => {
          this.$message.success("验证码已发送");
          // 倒计时逻辑
          this.forgetBtnDisabled = true;
          let count = 60;
          this.forgetBtnText = `${count}s后重新获取`;
          const timer = setInterval(() => {
            count--;
            this.forgetBtnText = `${count}s后重新获取`;
            if (count <= 0) {
              clearInterval(timer);
              this.forgetBtnDisabled = false;
              this.forgetBtnText = "获取验证码";
            }
          }, 1000);
        })
        .catch(() => {
          this.forgetBtnDisabled = false;
          this.$message.error("验证码发送失败");
        });
    },

    // 3. 忘记密码 - 提交重置
    submitForgetPwd() {
      this.$refs.forgetForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          const Params = {
            account: this.forgetForm.account,
            code: this.forgetForm.code,
            newPassword: this.forgetForm.newPass,
          };
          // 调用重置密码接口（需替换为实际接口）
          UserApi.resetPassword(Params)
            .then((res) => {
              this.logining = false;
              if (res.code === 1) {
                this.$message.success("密码重置成功，请重新登录");
                // 重置后返回密码登录表单
                this.switchForm("pwdLogin");
                // 清空密码登录表单的密码
                this.ruleForm.checkPass = "";
              } else {
                this.$message.error("密码重置失败");
              }
            })
            .catch(() => {
              this.logining = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 原有样式不变，新增少量适配样式
.login-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-repeat: no-repeat;
  background-position: center;
}

.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.4);

  .title {
    margin: 0 auto 20px auto;
    text-align: center;
    color: #66b1ff;
    font-size: 20px;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 10px;
  }

  .title1 {
    margin: 20px auto 20px auto;
    text-align: center;
    color: #66b1ff;
    font-size: 20px;
    border-top: 1px solid #d6d6d6;
    padding-top: 10px;
  }

  .remember {
    margin: 0 0 35px 0;
  }
}

.el-input--prefix .el-input__inner {
  padding-left: 35px;
}

.outerLayer {
  width: 100%;
  height: 100%;
  background: url(../../static/imgs/bg.jpg) no-repeat;
  background-size: cover;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  flex-direction: column;
  align-items: center;
  background-position: center;
}

.sellback {
  width: 420px;
  height: auto; /* 改为auto，适配不同表单高度 */
  min-height: 350px;
  margin: 9% auto 0 auto;
  border-radius: 10px;
  padding: 20px 0; /* 增加内边距 */
}

.warp_content {
  width: 300px;
  margin: 0 auto;
  padding-top: 20px;
  text-align: center;
}

.warp_content .title {
  margin-top: 10px;
  padding-bottom: 30px;
  margin-bottom: 20px; /* 减少底部间距 */
  border-bottom: 1px solid #eee;
}

.warp_content .title h3 {
  font-size: 20px;
  color: #fff;
  line-height: 32px;
}

.forget_pwd {
  display: block;
  float: left;
  cursor: pointer;
  color: #fff;
  &:hover {
    color: #409eff;
  }
}

.login_yzm {
  display: block;
  float: right;
  cursor: pointer;
  color: #fff;
  &:hover {
    color: #409eff;
  }
}

// 适配验证码输入框和按钮的布局
.el-form-item {
  overflow: hidden; /* 清除浮动 */
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue